import { Link } from 'react-router-dom';
import Header from '@/components/feature/Header';
import Footer from '@/components/feature/Footer';
import PageHero from '@/components/feature/PageHero';
import CtaSection from '@/components/feature/CtaSection';
import { testimonials } from '@/mocks/testimonials';
import { company } from '@/mocks/company';

const heroImg = '/assets/klob-hero-referenzen.jpg';

export default function Referenzen() {
  return (
    <div className="min-h-screen bg-background-50 text-foreground-50 font-sans">
      <Header />
      <main>
        <PageHero
          eyebrow="Bewertungen"
          title={<>Das sagen unsere <span className="text-primary-500">Kunden</span></>}
          subtitle="Ehrliche Stimmen aus echten Google-Rezensionen — ein Auszug aus der Bewertung unserer Arbeit in Hollfeld und Umgebung."
          image={heroImg}
        />

        <section className="bg-background-50 py-24 lg:py-28">
          <div className="max-w-7xl mx-auto px-6 lg:px-8">
            <div className="flex flex-col gap-4">
              <span className="text-[12px] uppercase tracking-[0.25em] text-primary-400">Google Rezensionen</span>
              <h2 className="font-display text-4xl sm:text-5xl font-bold uppercase tracking-tight text-foreground-50">
                Bewertungen unserer <span className="text-primary-500">Kunden</span>
              </h2>
            </div>

            <div className="mt-10 flex flex-wrap items-center gap-6 rounded-sm border border-primary-500/30 bg-background-100 px-6 py-8">
              <p className="font-display text-7xl font-bold text-primary-300">{company.rating}</p>
              <div className="flex flex-col gap-1">
                <div className="flex text-primary-400 gap-0.5">
                  {[...Array(5)].map((_, i) => (
                    <i key={i} className={`ri-star-${i < 4 ? 'fill' : 'half-fill'} text-xl`}></i>
                  ))}
                </div>
                <p className="text-base text-foreground-100/80">
                  von 5 bei Google · {company.reviewCount} Rezensionen
                </p>
              </div>
            </div>

            <div className="mt-10 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
              {testimonials.map((t, i) => (
                <figure
                  key={i}
                  className="flex flex-col gap-4 rounded-sm border border-background-300/60 bg-background-100 p-7 transition-all duration-300 hover:-translate-y-1 hover:border-primary-500/40"
                >
                  <div className="flex text-primary-500 gap-0.5">
                    {[...Array(5)].map((_, k) => (
                      <i key={k} className="ri-star-fill text-sm"></i>
                    ))}
                  </div>
                  <blockquote className="text-lg leading-relaxed text-foreground-100/85">„{t.text}"</blockquote>
                  <div className="mt-auto flex items-center gap-2 text-[13px] text-foreground-400">
                    <span className="w-2 h-2 rounded-full bg-primary-500"></span>
                    {t.source}
                  </div>
                </figure>
              ))}
            </div>

            <div className="mt-14 flex flex-col gap-5 rounded-sm border border-background-300/60 bg-background-100 p-8 sm:flex-row sm:items-center sm:justify-between">
              <div>
                <h3 className="font-display text-2xl font-bold uppercase tracking-tight text-foreground-50">
                  Ihre Meinung zählt
                </h3>
                <p className="mt-2 max-w-xl text-base leading-relaxed text-foreground-400">
                  Sie waren mit unserer Arbeit zufrieden? Wir freuen uns über Ihre Bewertung bei Google — sie hilft uns
                  und anderen Kundinnen und Kunden.
                </p>
              </div>
              <Link
                to="/kontakt"
                className="inline-flex items-center justify-center h-12 px-7 rounded-md bg-primary-500 hover:bg-primary-600 text-background-50 font-semibold cursor-pointer whitespace-nowrap transition-colors"
              >
                Projekt anfragen <i className="ri-arrow-right-line ml-2"></i>
              </Link>
            </div>
          </div>
        </section>

        <CtaSection />
      </main>
      <Footer />
    </div>
  );
}